export default {"src":"/_next/static/media/playground.96954159.svg","height":486,"width":486,"blurWidth":0,"blurHeight":0};